import { ApiRequest } from "../../services/api"

export const PatchAssignUserInstruction = async (userId, assignedTo) => {
    return await ApiRequest('PATCH', "admin/users-with-instructions/assign", {
        user_id: userId,
        assigned_to: assignedTo
    });
};

export const PatchUpdatePhoneNumber = async (userId, phoneNumber) => {
    return await ApiRequest('PATCH', `admin/users/${userId}/phone-number-update`, {
        phone_number: phoneNumber
    });
};

export const PatchUpdateCoupon = async (couponId, data) => {
    return await ApiRequest('PATCH', `admin/coupons/${couponId}`, data);
};

export const PatchUpdateCreditPackage = async (packageId, data) => {
    return await ApiRequest('PATCH', `admin/credit-packages/${packageId}`, data);
};

export const PatchUpdateUserCommunityCaste = async (userId, caste) => {
    return await ApiRequest('PATCH', "admin/update-user-community-caste", {
        user_id: userId,
        caste: caste
    });
};

export const PatchHoldUser = async (userId, holdStartedAt, holdDurationDays, holdReason) => {
    return await ApiRequest('PATCH', `users/hold-user?user_id=${userId}`, {
        hold_started_at: holdStartedAt,
        hold_duration_days: holdDurationDays,
        hold_reason: holdReason
    });
};

export const PatchUnholdUser = async (userId) => {
    return await ApiRequest('PATCH', `users/unhold-user?user_id=${userId}`);
};

export const PatchUpdateTransactionStatus = async (transactionId, data) => {
    return await ApiRequest('PATCH', `admin/v2/transactions/${transactionId}/status`, data);
};
